import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/math';

export default function MathGuide() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Everything in the Math section: algebra, advanced math, problem-solving and data analysis, and geometry and trigonometry."
      parts={parts}
      tabbed
    />
  );
}
